import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { openEntityModal } from "../../../Store";
import { AdminButton } from "../../../../../SharedComponents/ListView";

export default function UpdateTestButton({ test }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch(openEntityModal(test));
  };

  return (
    <AdminButton variant="outline" onClick={openModal}>
      {t("edit")}
    </AdminButton>
  );
}
